export enum LanguageEnum {
    fr = 'fr',
    nl = 'nl'
}